'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import { ObjectCategory } from 'FileManagerCore/Constants';
import { isFile } from 'FileManagerCore/utils/FoldersAndFiles';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import * as ModalTypes from '../enums/ModalTypes';
import { openModal } from '../actions/Actions';
import { jsx as _jsx } from "react/jsx-runtime";
class MoveButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleMoveButtonClick = () => {
      const {
        object
      } = this.props;
      const objectCategory = isFile(object) ? ObjectCategory.FILE : ObjectCategory.FOLDER;
      this.props.openModal(ModalTypes.MOVE, {
        objectCategory,
        objectId: object.get('id')
      });
    };
  }
  render() {
    const {
      object,
      isReadOnly,
      size
    } = this.props;
    return /*#__PURE__*/_jsx(ScopedFeatureTooltip, {
      children: /*#__PURE__*/_jsx(UIButton, {
        size: size,
        use: "tertiary-light",
        onClick: this.handleMoveButtonClick,
        disabled: isReadOnly,
        "data-test-id": isFile(object) ? 'move-file-button' : 'move-folder-button',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerDashboard.actions.move"
        })
      })
    });
  }
}
MoveButton.propTypes = {
  object: PropTypes.instanceOf(Immutable.Map).isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  size: UIButton.propTypes.size
};
MoveButton.defaultProps = {
  size: 'small'
};
const mapDispatchToProps = {
  openModal
};
export default connect(null, mapDispatchToProps)(MoveButton);